import { getApi } from "@/app/api/config";
import type { ErrorResponse } from "@/app/types/error";
import { ELocalStorageKeys } from "@/app/types/localStorage";
import { getItemSessionStorage } from "@/lib/utils";

export type ProviderAccessState =
  | "DISABLED"
  | "NEEDS_ONBOARDING"
  | "NEEDS_ENTITLEMENT"
  | "ACTIVE";

export const getProviderAccessState = () => {
  const token = getItemSessionStorage(ELocalStorageKeys.TOKEN);

  if (!token) {
    throw new Error("Provider authentication required.");
  }

  return getApi<
    | {
        status: "success";
        data: {
          accessState: ProviderAccessState;
          registrationFlow: "LEGACY" | "SELF_SERVICE";
        };
      }
    | ErrorResponse
  >("/provider/access-state", {}, token);
};
